/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VideoDto } from '../../models/video-dto';

export interface VideoControllerFindAll$Params {
}

export function videoControllerFindAll(http: HttpClient, rootUrl: string, params?: VideoControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VideoDto>>> {
  const rb = new RequestBuilder(rootUrl, videoControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VideoDto>>;
    })
  );
}

videoControllerFindAll.PATH = '/api/videos';
